module.exports = __webpack_public_path__ + "src/assets/individualImages/melliferaGasMask.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/melliferaGasMask.png
// module id = ./src/assets/individualImages/melliferaGasMask.png
// module chunks = 0